import axios from 'axios';
import { Storage } from 'react-jhipster';

import { REQUEST, SUCCESS, FAILURE } from 'app/shared/reducers/action-type.util';
import { setLocale } from 'app/shared/reducers/locale';

export const ACTION_TYPES = {
  LOGIN: 'authentication/LOGIN',
  LOGIN_TOKEN: 'authentication/LOGIN/TOKEN',
  LOGIN_EID_CODE: 'authentication/LOGIN/EID/CODE',
  LOGIN_EID_TYPE_PASSWORD: 'authentication/LOGIN/EID/TYPE/PASSWORD',
  GET_SESSION: 'authentication/GET_SESSION',
  LOGOUT: 'authentication/LOGOUT',
  CLEAR_AUTH: 'authentication/CLEAR_AUTH',
  ERROR_MESSAGE: 'authentication/ERROR_MESSAGE'
};

const AUTH_TOKEN_KEY = 'jhi-authenticationToken';

const initialState = {
  loading: false,
  isAuthenticated: false,
  loginSuccess: false,
  loginError: false, // Errors returned from server side
  showModalLogin: false,
  account: {} as any,
  errorMessage: null as string, // Errors returned from server side
  redirectMessage: null as string,
  sessionHasBeenFetched: false,
  idToken: null as string,
  logoutUrl: '/'
};

export type AuthenticationState = Readonly<typeof initialState>;

// Reducer

export default (state: AuthenticationState = initialState, action): AuthenticationState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.LOGIN):
    case REQUEST(ACTION_TYPES.LOGIN_TOKEN):
    case REQUEST(ACTION_TYPES.LOGIN_EID_CODE):
    case REQUEST(ACTION_TYPES.LOGIN_EID_TYPE_PASSWORD):
    case REQUEST(ACTION_TYPES.GET_SESSION):
      return {
        ...state,
        loading: true
      };
    case FAILURE(ACTION_TYPES.LOGIN):
      return {
        ...initialState,
        errorMessage: action.payload,
        showModalLogin: true,
        loginError: true
      };
    case FAILURE(ACTION_TYPES.LOGIN_EID_TYPE_PASSWORD):
      return {
        ...initialState,
        errorMessage: action.payload,
        showModalLogin: true,
        loginError: true
      };
    case FAILURE(ACTION_TYPES.LOGIN_EID_CODE):
      return {
        ...initialState,
        errorMessage: action.payload,
        showModalLogin: true,
        loginError: true
      };
    case FAILURE(ACTION_TYPES.GET_SESSION):
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        sessionHasBeenFetched: true,
        showModalLogin: true,
        errorMessage: action.payload
      };
    case FAILURE(ACTION_TYPES.LOGIN_TOKEN):
      return {
        ...state,
        loading: false,
        isAuthenticated: false,
        sessionHasBeenFetched: true,
        showModalLogin: true,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.LOGIN):
      return {
        ...state,
        loading: false,
        loginError: false,
        showModalLogin: false,
        loginSuccess: true
      };
    case ACTION_TYPES.LOGOUT:
      return {
        ...initialState,
        showModalLogin: true
      };
    case SUCCESS(ACTION_TYPES.GET_SESSION): {
      const isAuthenticated = action.payload && action.payload.data;
      return {
        ...state,
        isAuthenticated,
        loading: false,
        sessionHasBeenFetched: true,
        account: action.payload.data
      };
    }
    case SUCCESS(ACTION_TYPES.LOGIN_EID_TYPE_PASSWORD): {
      const isAuthenticated = action.payload && action.payload.data;
      return {
        ...state,
        isAuthenticated,
        loading: false,
        sessionHasBeenFetched: true,
        account: action.payload.data,
        showModalLogin: false,
        loginSuccess: true
      };
    }
    case SUCCESS(ACTION_TYPES.LOGIN_EID_CODE): {
      const isAuthenticated = action.payload && action.payload.data;
      const bearerToken = action.payload.headers.authorization;
      if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
        const jwt = bearerToken.slice(7, bearerToken.length);
        Storage.session.set(AUTH_TOKEN_KEY, jwt);
      }
      if (action.payload.data && action.payload.data.login) {
        Storage.session.set('techID', action.payload.data.login);
      }
      return {
        ...state,
        isAuthenticated,
        loading: false,
        sessionHasBeenFetched: true,
        account: action.payload.data,
        showModalLogin: false,
        loginSuccess: true
      };
    }
    case SUCCESS(ACTION_TYPES.LOGIN_TOKEN): {
      const isAuthenticated = action.payload && action.payload.data;
      return {
        ...state,
        isAuthenticated,
        loading: false,
        sessionHasBeenFetched: true,
        account: action.payload.data,
        showModalLogin: false,
        loginSuccess: true
      };
    }
    case ACTION_TYPES.ERROR_MESSAGE:
      return {
        ...initialState,
        showModalLogin: true,
        redirectMessage: action.message
      };
    case ACTION_TYPES.CLEAR_AUTH:
      return {
        ...state,
        loading: false,
        showModalLogin: true,
        isAuthenticated: false
      };
    default:
      return state;
  }
};

export const displayAuthError = message => ({ type: ACTION_TYPES.ERROR_MESSAGE, message });

export const getSession = () => async (dispatch, getState) => {
  // if(Storage.session.get(AUTH_TOKEN_KEY)){
  await dispatch({
    type: ACTION_TYPES.GET_SESSION,
    payload: axios.get('api/account')
  });

  const { account } = getState().authentication;
  if (account && account.langKey) {
    const langKey = Storage.session.get('locale', account.langKey);
    await dispatch(setLocale(langKey));
  }
  // }else{
  //   this.sessionHasBeenFetched = true;
  // }
};

export const login = (username, password, rememberMe = false) => async (dispatch, getState) => {
  const result = await dispatch({
    type: ACTION_TYPES.LOGIN,
    payload: axios.post('api/authenticate', { username, password, rememberMe })
  });
  const bearerToken = result.value.headers.authorization;
  if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
    const jwt = bearerToken.slice(7, bearerToken.length);
    if (rememberMe) {
      Storage.local.set(AUTH_TOKEN_KEY, jwt);
    } else {
      Storage.session.set(AUTH_TOKEN_KEY, jwt);
    }
  }
  await dispatch(getSession());
};

export const eIdLogin = (username, password, rememberMe, type) => async (dispatch, getState) => {
  const result = await dispatch({
    type: ACTION_TYPES.LOGIN_EID_TYPE_PASSWORD,
    payload: axios.post('login/eid/password', { username, password, rememberMe, type })
  });
  const bearerToken = result.value.headers.authorization;
  if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
    const jwt = bearerToken.slice(7, bearerToken.length);
    if (rememberMe) {
      Storage.local.set(AUTH_TOKEN_KEY, jwt);
    } else {
      Storage.session.set(AUTH_TOKEN_KEY, jwt);
    }
  }
};

export const eIDAuthentication = (code, state) => async (dispatch, getState) => {
  const result = await dispatch({
    type: ACTION_TYPES.LOGIN_EID_CODE,
    payload: axios.post('login/eid/code', null, {
      params: {
        code: code,
        state: state
      }
    })
  });
  // const bearerToken = result.value.headers.authorization;
  // if (bearerToken && bearerToken.slice(0, 7) === 'Bearer ') {
  //   const jwt = bearerToken.slice(7, bearerToken.length);
  //   Storage.session.set(AUTH_TOKEN_KEY, jwt);
  // }
};

export const loginToken = (certSerial, certBase64) => async (dispatch, getState) => {
  alert(certSerial);
  await dispatch({
    type: ACTION_TYPES.LOGIN_TOKEN,
    payload: axios.post('login/eid/token', null, {
      params: {
        certSerial: certSerial,
        certBase64: certBase64
      }
    })
  });
};

export const clearAuthToken = () => {
  if (Storage.local.get(AUTH_TOKEN_KEY)) {
    Storage.local.remove(AUTH_TOKEN_KEY);
  }
  if (Storage.session.get(AUTH_TOKEN_KEY)) {
    Storage.session.remove(AUTH_TOKEN_KEY);
  }
};

export const logout = () => dispatch => {
  clearAuthToken();
  dispatch({
    type: ACTION_TYPES.LOGOUT
  });
};

export const clearAuthentication = messageKey => (dispatch, getState) => {
  clearAuthToken();
  dispatch(displayAuthError(messageKey));
  dispatch({
    type: ACTION_TYPES.CLEAR_AUTH
  });
};
